import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import reducer from './reducers';
import middleware from './middlewares';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { usePromiseTracker } from 'react-promise-tracker';
import Loader from 'react-promise-loader';
require('dotenv').config();

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['authedUser', 'currentTab'],
};
const persistedReducer = persistReducer(persistConfig, reducer);

let store = createStore(persistedReducer, middleware);
let persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
        <Loader promiseTracker={usePromiseTracker} color='#4c6686' />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
